import request from '@/utils/request';

export interface NotificationVO {
  id: number;
  userId: number;
  fromUserId: number;
  fromUserName: string;
  fromUserAvatar: string;
  type: number; // 1-点赞帖子，2-点赞评论，3-评论帖子，4-回复评论，5-关注，6-收藏帖子
  targetType: number; // 1-帖子，2-评论，3-用户
  targetId: number;
  content: string;
  isRead: number; // 0-未读，1-已读
  readTime?: string;
  createTime: string;
}

export interface PageResult<T> {
  records: T[];
  total: number;
  current: number;
  size: number;
}

// 实际的API响应格式（经过响应拦截器处理后）
export interface NotificationListResponse {
  records: NotificationVO[];
  total: number;
  current: number;
  size: number;
}

export const notificationApi = {
  // 获取消息列表
  getNotificationList(page = 1, pageSize = 20) {
    console.log(`[Notification API] Fetching notification list - page: ${page}, pageSize: ${pageSize}`);
    return request<NotificationListResponse>({
      url: '/user/notification/list',
      method: 'get',
      params: { page, pageSize }
    }).then(response => {
      console.log('[Notification API] Response received:', response);
      return response;
    }).catch(error => {
      console.error('[Notification API] Error fetching notification list:', error);
      throw error;
    });
  },

  // 标记消息为已读
  markNotificationAsRead(notificationId: number) {
    console.log(`[Notification API] Marking notification as read - id: ${notificationId}`);
    return request({
      url: `/user/notification/read/${notificationId}`,
      method: 'put'
    }).then(response => {
      console.log('[Notification API] Mark as read response:', response);
      return response;
    }).catch(error => {
      console.error('[Notification API] Error marking notification as read:', error);
      throw error;
    });
  },

  // 全部标记为已读
  markAllNotificationsAsRead() {
    console.log('[Notification API] Marking all notifications as read');
    return request({
      url: '/user/notification/read-all',
      method: 'put'
    }).then(response => {
      console.log('[Notification API] Mark all as read response:', response);
      return response;
    }).catch(error => {
      console.error('[Notification API] Error marking all notifications as read:', error);
      throw error;
    });
  },

  // 获取未读消息数
  getUnreadCount() {
    console.log('[Notification API] Fetching unread count');
    return request<number>({
      url: '/user/notification/unread-count',
      method: 'get'
    }).then(response => {
      console.log('[Notification API] Unread count response:', response);
      return response;
    }).catch(error => {
      console.error('[Notification API] Error fetching unread count:', error);
      throw error;
    });
  },

  // 删除消息
  deleteNotification(notificationId: number) {
    console.log(`[Notification API] Deleting notification - id: ${notificationId}`);
    return request({
      url: `/user/notification/${notificationId}`,
      method: 'delete'
    }).then(response => {
      console.log('[Notification API] Delete response:', response);
      return response;
    }).catch(error => {
      console.error('[Notification API] Error deleting notification:', error);
      throw error;
    });
  },

  // 清空所有消息
  clearAllNotifications() {
    console.log('[Notification API] Clearing all notifications');
    return request({
      url: '/user/notification/clear-all',
      method: 'delete'
    }).then(response => {
      console.log('[Notification API] Clear all response:', response);
      return response;
    }).catch(error => {
      console.error('[Notification API] Error clearing all notifications:', error);
      throw error;
    });
  }
};